export enum CloseReason {
  CLOSE, CANCEL, CONFIRM
}
